import React from "react";
import "../../../css/BoletinOficial/declaraciones.css";
import IframePage from "../BoletinOFicial/IframePage";

const ActasSesiones = () => (
  <IframePage
    title="ACTAS DE SESIONES"
    description="Un gobierno abierto y transparente que pone a disposición de los ciudadanos información relevante para promover mayor participación y cercanía."
    iframeUrl="https://ciudaddeoliva.gov.ar/noticias/actas-de-sesiones-ordinarias"
    classPrefix="declaraciones"
  />
);

export default ActasSesiones;
